/**
 * Registers the service worker for offline support + Web Push. Only in
 * production builds — registering in dev interferes with Vite's HMR module
 * requests. (Push subscription separately ensures registration when enabled.)
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Registration failures are non-fatal; the app still works online.
    });
  });
}
